export interface NewsItem {
  id: string;
  title: string;
  date: string;
  category: "作品资讯" | "人物动态" | "行业观察" | "站务公告";
  summary: string;
  content: string[];
  relatedActressIds: string[];
  relatedWorkIds: string[];
}

export const newsList: NewsItem[] = [
  {
    id: "n01",
    title: "《东京的四个季节》第二季制作决定，原班阵容回归",
    date: "2026-10-12",
    category: "作品资讯",
    summary: "制作方于本周正式公布续订消息，第二季将以「冬」与「春」两个单元展开，预计 2027 年春季开机。",
    content: [
      "据制作方公开消息，去年播出后引发长期讨论的电视剧《东京的四个季节》已确定制作第二季。新一季将延续第一季的四季结构，但把叙事重心放在冬季与春季两个单元，聚焦四位主角在坡道街区之外的生活。",
      "主演绫濑真央、神宫寺葵与小野寺枫均确认回归，编剧团队保持不变，导演仍由佐藤洋平担任。制作方表示，第二季会增加实景拍摄比例，部分镜头将回到第一季的取景地补拍，以保持街区的时间连续性。",
      "该剧第一季共十集，播出期间连续八周进入话题榜，并在亚洲电视剧评选中获得最佳群像演出提名。第二季预计于 2027 年春季开机，播出时间尚未确定。",
    ],
    relatedActressIds: ["a01", "a05", "a09"],
    relatedWorkIds: ["w03"],
  },
  {
    id: "n02",
    title: "绫濑真央宣布回归文艺题材，新作明年开机",
    date: "2026-10-08",
    category: "人物动态",
    summary: "在完成舞台剧行程后，绫濑真央将投入新片《海雾之下》的拍摄，这也是她与导演森田诚的第三次合作。",
    content: [
      "绫濑真央的事务所今日确认，她将在明年一月进入新片《海雾之下》的剧组。影片由森田诚执导，讲述一位气象观测员在离岛工作期间重新整理家族记忆的故事。",
      "这将是两人自《盛夏的最后一封信》与《白夜的花火》之后的第三次合作。绫濑在访谈中提到，这次的剧本更接近散文结构，「几乎没有强烈的戏剧冲突，但每一场戏都在积累情绪」。",
      "为准备角色，她已开始进行为期两个月的地方生活体验，并学习基础的气象观测工作。影片预计 2027 年秋季上映。",
    ],
    relatedActressIds: ["a01"],
    relatedWorkIds: ["w01", "w17"],
  },
  {
    id: "n03",
    title: "第 18 届日本影视作品大赏公布提名名单",
    date: "2026-09-30",
    category: "行业观察",
    summary: "本届共设十二个奖项，《静默的证词》以六项提名领跑，多部小成本文艺作品首次进入主竞赛单元。",
    content: [
      "第 18 届日本影视作品大赏于昨日公布提名名单。《静默的证词》获得最佳剧集、最佳女主角、最佳女配角、最佳编剧等六项提名，为本届提名最多的作品。",
      "值得关注的是，多部低预算文艺电影进入了主竞赛单元，其中《玻璃与光》与《海边的旧书店》分别在摄影与美术部门获得提名，显示评审口味正在向多样化倾斜。",
      "颁奖典礼将于 11 月下旬举行，本届新设「最佳群像演出」奖项，用以鼓励在多人叙事中表现突出的作品。",
    ],
    relatedActressIds: ["a11", "a17", "a24", "a02"],
    relatedWorkIds: ["w14", "w09", "w04"],
  },
  {
    id: "n04",
    title: "《白夜的花火》首周票房超出预期，口碑持续走高",
    date: "2026-09-22",
    category: "作品资讯",
    summary: "影片上映首周动员观众数突破发行方预期，多家影院宣布加开场次，导演与主演将出席巡回见面会。",
    content: [
      "《白夜的花火》于 9 月中旬上映，首周票房表现超出发行方预期。影片以极昼小镇的烟火大会为核心意象，视听语言受到观众与影评人的一致好评。",
      "发行方表示，将在主要城市追加场次，并安排导演森田诚与主演绫濑真央、藤井纱良的巡回见面会。首批场次于上周末开放后很快售罄。",
      "评论普遍认为，影片对记忆与遗愿的处理克制而有力量，两位主演的对手戏是整部作品的情感支点。",
    ],
    relatedActressIds: ["a01", "a11"],
    relatedWorkIds: ["w17"],
  },
  {
    id: "n05",
    title: "水城彩移籍白鹭制作，将专注电影与舞台领域",
    date: "2026-09-15",
    category: "人物动态",
    summary: "水城彩结束与旧事务所的合约，正式移籍白鹭制作。新阶段将以电影与舞台剧为主，减少电视剧出演频率。",
    content: [
      "水城彩于本月完成事务所移籍手续，新东家为以作者电影见长的白鹭制作。双方在联合声明中提到，未来将把重心放在电影与舞台领域。",
      "她在个人留言中写道：「过去几年接到了很多有趣的角色，但也有想更深入的部分。接下来希望用更慢的节奏完成每一部作品。」",
      "移籍后的首部作品尚未公布，据相关人士透露，可能是一部双人舞台剧，预计明年春天在东京与大阪上演。",
    ],
    relatedActressIds: ["a02"],
    relatedWorkIds: ["w02", "w09"],
  },
  {
    id: "n06",
    title: "高梨沙耶出道十五周年纪念企划启动",
    date: "2026-09-02",
    category: "人物动态",
    summary: "企划包含经典作品重映、长篇访谈与一场限定朗读会，回顾她从配角到主演的十五年。",
    content: [
      "高梨沙耶迎来出道十五周年，事务所公布了一系列纪念企划。其中包括三部代表作品的重映、一部长篇访谈影像，以及一场限定两百席的朗读会。",
      "重映片单包括《海边的旧书店》与两部早期电视剧剪辑版。高梨表示，很期待在影院重新看到这些作品，「有些镜头当年看不懂，现在会想起很多事」。",
      "朗读会定于 11 月在东京举行，内容为她亲自挑选的三篇短篇小说。门票将以抽选方式发放。",
    ],
    relatedActressIds: ["a04"],
    relatedWorkIds: ["w04"],
  },
  {
    id: "n07",
    title: "《京都夜行》获亚洲电视剧奖最佳摄影",
    date: "2026-08-21",
    category: "行业观察",
    summary: "剧集凭借实景拍摄与夜景光线设计获奖，评委会称其「让城市本身成为主角」。",
    content: [
      "《京都夜行》在今年的亚洲电视剧奖中获得最佳摄影。评委会在颁奖词中提到，剧组坚持实景与自然光拍摄，让城市空间成为叙事的一部分。",
      "摄影指导在获奖感言中感谢了长谷川凛与川岛诗织的配合，称两位主演在低温夜景中的稳定表演让长镜头得以成立。",
      "该剧目前已在多个海外平台上线，配有四语字幕。制作方表示，未来会考虑推出以京都取景地为主题的影像特辑。",
    ],
    relatedActressIds: ["a12", "a18"],
    relatedWorkIds: ["w07"],
  },
  {
    id: "n08",
    title: "新人访谈：宫下遥谈第一次主演的紧张与收获",
    date: "2026-08-10",
    category: "人物动态",
    summary: "从地方选拔到网络剧主演，宫下遥分享了她对表演的理解，以及对未来作品的期待。",
    content: [
      "宫下遥在 2023 年通过地方选拔进入影视圈，短短两年便获得了网络剧的主演机会。谈到第一次拿到完整剧本时，她说自己「把每一场戏都抄了一遍，怕记不住情绪的顺序」。",
      "她认为自己的优势是「不会想太多」，「导演说开始，我就先把当下做好，其他的交给剪辑和对手演员」。这种直接的方式让她在青春题材中显得格外自然。",
      "对于未来，她希望尝试悬疑题材，也想去舞台剧现场学习。「现在还在读书，能做的就是把每一部作品认真完成。」",
    ],
    relatedActressIds: ["a13"],
    relatedWorkIds: ["w08", "w15"],
  },
  {
    id: "n09",
    title: "夏季作品特辑：五部适合安静观看的文艺电影",
    date: "2026-07-28",
    category: "作品资讯",
    summary: "编辑部整理了五部以光线与静默见长的作品，包括《玻璃与光》《海边的旧书店》等。",
    content: [
      "盛夏并不只属于热闹的商业片。本期特辑挑选了五部节奏缓慢、以光线与静默见长的作品，适合在一个不赶时间的午后观看。",
      "其中包括《玻璃与光》《海边的旧书店》《雪国来信》与《樱花落下的那天》，以及较早的《六本木的黄昏》。这些作品的共同点是大量使用自然光，把情绪交给环境而不是台词。",
      "如果你刚开始接触这类作品，建议从《海边的旧书店》开始，它的叙事最平易近人；而《玻璃与光》则更接近纯粹的视听体验。",
    ],
    relatedActressIds: ["a02", "a04", "a10", "a14"],
    relatedWorkIds: ["w09", "w04", "w12", "w05"],
  },
  {
    id: "n10",
    title: "资料库更新说明：新增 24 位女优档案与 18 部作品条目",
    date: "2026-07-15",
    category: "站务公告",
    summary: "本次更新补充了女优的基础资料、代表作品标签与关联新闻，同时优化了筛选与排序体验。",
    content: [
      "本站资料库完成新一轮更新，新增 24 位女优档案与 18 部影视作品条目，并为每位女优补充了代表作品标签、所属事务所与活跃状态。",
      "本次同步优化了分类页的筛选逻辑，支持年龄、出道年份、活跃状态与事务所的多选组合；作品列表页新增按评分与热度排序。",
      "所有资料均为站内示例内容，用于演示检索与浏览体验。如发现信息错漏，欢迎通过关于页的联系方式反馈。",
    ],
    relatedActressIds: [],
    relatedWorkIds: [],
  },
];